import casusBackend, {CasusInResponse} from '@lexian/api/casus-api';
import {
  CommonRequestOptions,
  PaginatedEndpointArguments,
} from '_/utilities/types';

export type SearchAllCasusFilters = Omit<
  Parameters<typeof casusBackend.searchAllCasus>[0]['parameters'],
  keyof CommonRequestOptions | keyof PaginatedEndpointArguments
>;

export type SearchCasusFilters = Omit<SearchAllCasusFilters, 'ids' | 'query'>;

export type CasusState = CasusInResponse['state'];

// keep in sync with 'CasusReadonlyReason.kt'
export enum CasusReadonlyReason {
  LOCKED = 'LOCKED',
  ARCHIVED = 'ARCHIVED',
}
